import Vue from 'vue'
import Router from 'vue-router'
// import store from './store'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/404',
      name: '404',
      component: () => import('./views/NotFound')
    },
    {
      // Here's the new catch all route
      path: '*',
      redirect: { name: 'home' }
    },
    {
      path: '/',
      name: 'home',
      component: () => import('./views/Shop')
    },
    {
      path: '/fruit/:shopEditionProductId',
      name: 'shop-product-detail',
      component: () => import('./views/ShopProductDetail')
    },
    {
      path: '/checkout',
      name: 'shop-checkout',
      component: () => import('./views/ShopCheckout')
    },
    {
      path: '/confirm',
      name: 'shop-confirm',
      component: () => import('./views/ShopConfirm')
    }
  ]
})

export default router
